/**
 * Set up routing for all Site views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import site views
import AdminCreateSite from './views/AdminCreateSite.js.jsx';
import AdminSiteList from './views/AdminSiteList.js.jsx';
import AdminSingleSite from './views/AdminSingleSite.js.jsx';
import AdminUpdateSite from './views/AdminUpdateSite.js.jsx';

class SiteAdminRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <YTRoute role="admin" exact path="/admin/sites" component={AdminSiteList} />
        <YTRoute role="admin" exact path="/admin/sites/new" component={AdminCreateSite} />
        <YTRoute role="admin" exact path="/admin/sites/:siteId" component={AdminSingleSite}/>
        <YTRoute role="admin" exact path="/admin/sites/:siteId/update" component={AdminUpdateSite}/>
      </Switch>
    )
  }
}

export default SiteAdminRouter;



// WEBPACK FOOTER //
// modules/site/SiteAdminRouter.js.jsx